import React from 'react';

const Loader = (props) => {
	const color = props?.color ?? 'rgba(var(--main-text-color), 1)';
	const size = props?.size ?? '5px';
	const margin = props?.margin ?? '1px';

	return (
		<span class="gui_loader_animation">
			&nbsp;
			<span style={{backgroundColor:color, width:size, height:size, margin:margin}} />
			<span style={{backgroundColor:color, width:size, height:size, margin:margin}} />
			<span style={{backgroundColor:color, width:size, height:size, margin:margin}} />
			&nbsp;
		</span>
	)
}

export default Loader;